import { render, staticRenderFns } from "./HallFooter.vue?vue&type=template&id=271d4efa&scoped=true&"
import script from "./HallFooter.vue?vue&type=script&lang=js&"
export * from "./HallFooter.vue?vue&type=script&lang=js&"
import style0 from "./HallFooter.vue?vue&type=style&index=0&id=271d4efa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d4efa",
  null
  
)

export default component.exports